namespace Areas.ReAssigned {
    "use strict";

    export function goBack() {
        window.history.back();
    }

    export function gotoInspections() {
        var dataGrid = $('#InspectionReAssignedGrid').dxDataGrid('instance');
        var selectedRow: any = dataGrid.getSelectedRowsData();

        if (selectedRow[0] != null) {
            var projectId = selectedRow[0].inspectionProjectId;
            var linkInfo = "/Inspections/List/Index/" + projectId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function gotoReAssignedList() {
        var linkInfo = "/Inspectors/ReAssigned/Index";
        location.href = linkInfo;
    }
   

   export function gotoMultipleEdit() {
       var dataGrid = $('#InspectionReAssignedGrid').dxDataGrid('instance');
       var dataId = dataGrid.getSelectedRowKeys()[0];
       if (dataId != null) {
           var linkInfo = "/Inspections/Assign/Index/" + dataId.toString() + "";
           location.href = linkInfo;
       }
       else {
           DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
       }
   }

   export function gotoEdit() {
       var dataGrid = $('#InspectionReAssignedGrid').dxDataGrid('instance');
        var dataId = dataGrid.getSelectedRowKeys()[0];
        if (dataId != null) {
            var linkInfo = "/Inspections/Assign/Index/" + dataId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function gotoView() {
        var dataGrid = $('#InspectionReAssignedGrid').dxDataGrid('instance');
        var dataId = dataGrid.getSelectedRowKeys()[0];
        if (dataId != null) {
            var linkInfo = "/Inspections/View/Index/" + dataId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function viewLink(cellElement, cellInfo) {
        var fieldData = cellInfo.data.inspectionId;
        var linkInfo = "<a href= '/Inspections/View/Index/" + String(fieldData) + "'>View</a>"
        cellElement.html(linkInfo);
    }

   }
